import { PER_PAGE_TYPES } from "enums";
import { ThreadListModel } from "models";
import { ThreadSearchOptions } from "models/ThreadSearchOptions";
import React from "react";

type PROPS = {
  options: ThreadSearchOptions;
  data: ThreadListModel;
  onSearch: () => void;
};

const ThreadSearchOptionsArea: React.FC<PROPS> = (props) => {
  // 状態
  const [receiveStatus, setReceiveStatus] = React.useState(0);
  // キーワード
  const [keyword, setKeyword] = React.useState("");
  // 完了も表示
  const [isShowAll, setIsShowAll] = React.useState(false);

  const onReset = () => {
    // delete props.options.thread_send_receive_status;
    // delete props.options.keyword;
    // delete props.options.is_show_all;

    // setReceiveStatus(0);
    // setKeyword("");
    // setIsShowAll(false);

    for (let k in props.options) {
      delete (props.options as any)[k];
    }
    props.options.get_count = PER_PAGE_TYPES.DEFAULT;
    props.onSearch();
  };

  React.useEffect(() => {
    const _ = props.options.thread_send_receive_status;
    if (_ !== undefined) {
      setReceiveStatus(_);
    } else {
      setReceiveStatus(0);
    }
    if (props.options.keyword !== undefined) {
      setKeyword(props.options.keyword);
    } else {
      setKeyword("");
    }
    if (props.options.is_show_all !== undefined) {
      setIsShowAll(props.options.is_show_all);
    } else {
      setIsShowAll(false);
    }
  }, [
    props.options.is_show_all,
    props.options.keyword,
    props.options.thread_send_receive_status,
  ]);

  return (
    <div className="m-4 border rounded p-4 flex flex-col gap-2">
      <div className="flex justify-between gap-4">
        <div className="flex items-center gap-4">
          <div>状態</div>
          <select
            className="w-40 cursor-pointer"
            value={receiveStatus}
            onChange={(e) => {
              const value = parseInt(e.target.value);
              if (isNaN(value)) {
                return;
              }
              setReceiveStatus(value);

              if (!value) {
                delete props.options.thread_send_receive_status;
              } else {
                props.options.thread_send_receive_status = value;
              }
            }}
          >
            <option value={0}>すべて</option>
            <option value={2}>受信</option>
            <option value={1}>送信済</option>
          </select>
        </div>
        <div className="flex-1 flex justify-between items-center gap-4">
          <div>キーワード</div>
          <input
            className="flex-1"
            value={keyword}
            onChange={(e) => {
              const value = e.target.value;
              setKeyword(value);
              if (value) {
                props.options.keyword = value;
              } else {
                delete props.options.keyword;
              }
            }}
            maxLength={50}
          />
        </div>
      </div>
      <div className="flex justify-between items-center gap-4">
        <label>
          <input
            type="checkbox"
            checked={isShowAll}
            onChange={(e) => {
              const value = e.target.checked;
              setIsShowAll(value);
              if (value) {
                props.options.is_show_all = true;
              } else {
                delete props.options.is_show_all;
              }
            }}
          />
          <span className="ml-2">完了も表示</span>
        </label>
        <div className="flex items-center gap-4">
          <div className="mt-2 underline cursor-pointer" onClick={onReset}>
            検索条件を解除
          </div>
          <button
            className="primary px-8 py-2"
            onClick={() => {
              props.onSearch();
            }}
          >
            検索
          </button>
        </div>
      </div>
    </div>
  );
};
export default ThreadSearchOptionsArea;
